module.exports = __webpack_public_path__ + "img/2.a05774c9.svg";